console.info(
  `   ___               _     ___    ___  \r\n  \/ _ \\  ___   _ __ | |_  ( _ )  \/ _ \\ \r\n \/ \/_)\/ \/ _ \\ | \'__|| __| \/ _ \\ | | | |\r\n\/ ___\/ | (_) || |   | |_ | (_) || |_| |\r\n\\\/      \\___\/ |_|    \\__| \\___\/  \\___\/ \r\n                                       \r\n https://www.port80webdesign.com`
);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  const details = summary.closest('.mega-menu');

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);

  if (!details) return;

  summary.addEventListener('mouseenter', (event) => {
    details.setAttribute('open', 'open');
    if (!event.target.nextElementSibling) return;
    details
      .querySelector('.before')
      .style.setProperty(
        '--width',
        `${event.target.nextElementSibling.offsetWidth}px`
      );
    details
      .querySelector('.before')
      .style.setProperty(
        '--height',
        `${event.target.nextElementSibling.offsetHeight}px`
      );
  });

  details.addEventListener('mouseleave', (event) => {
    event.target.removeAttribute('open');
  });

  summary.addEventListener('click', (event) => {
    if (!event.currentTarget.dataset.url) return;
    window.location = event.currentTarget.dataset.url;
  });
});

/* custom header icons with popup */
document.querySelectorAll('.custom-header-icon summary').forEach((summary) => {
  const parentEl = summary.closest('.header__icons');
  const details = summary.closest('[data-details]');
  summary.addEventListener('click', (event) => {
    const currentDetail = event.currentTarget.parentNode.dataset.details;
    parentEl
      .querySelectorAll(
        `.custom-header-icon:not([data-details="${currentDetail}"])`
      )
      .forEach((detail) => {
        detail.removeAttribute('open');
      });
  });

  summary.addEventListener('mouseenter', (event) => {
    details.setAttribute('open', 'open');
    if (!event.target.nextElementSibling) return;
    details
      .querySelector('.before')
      .style.setProperty(
        '--width',
        `${event.target.nextElementSibling.offsetWidth}px`
      );
    details
      .querySelector('.before')
      .style.setProperty(
        '--height',
        `${event.target.nextElementSibling.offsetHeight}px`
      );
  });

  details.addEventListener('mouseleave', (event) => {
    event.target.removeAttribute('open');
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true});

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (!this.closest('.product__info-container')) return;
    this.setBundleEl = this.closest('.product__info-container').querySelector(
      '[name="amount-bundle"]:checked'
    );

    if (!this.setBundleEl) return;
    this.input.addEventListener('change', this.onInputChange.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  onInputChange() {
    // set-bundle dropdown
    if (!this.setBundleEl) return;
    const changeEvent = new Event('change', {bubbles: true});
    this.setBundleEl = this.closest('.product__info-container').querySelector(
      '[name="amount-bundle"]:checked'
    );
    this.setBundleEl.dispatchEvent(changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {'Content-Type': 'application/json', Accept: `application/${type}`}
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.bind();
  }

  // Manually enabled bindings for ajax cart
  bind() {
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateSelectedInput();
    this.updateVolumeDiscounts();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVolumeDiscounts() {
    const volumeDiscounts = document.querySelector(
      '.product__info-wrapper volume-discounts'
    );
    if (!volumeDiscounts) return;
    volumeDiscounts.generate(this.currentVariant.price);
  }

  updateSelectedInput() {
    const variantSelectors = document.querySelectorAll(
      '[id^="MainProduct-"] select'
    );
    const fieldsets = document.querySelectorAll(
      '[id^="MainProduct-"] fieldset'
    );
    if (!variantSelectors.length || !fieldsets.length) return;
    variantSelectors.forEach((variantSelector, index) => {
      variantSelector.value = this.options[index];
    });
    fieldsets.forEach((fieldset, index) => {
      fieldset.querySelectorAll('input').forEach((radio) => {
        if (radio.value === this.options[index]) {
          radio.checked = true;
        }
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const glideGalleries = document.querySelectorAll(
      `[data-id=${this.dataset.section}-main-carousel], [data-id=${this.dataset.section}-secondary-carousel]`
    );

    glideGalleries.forEach((gallery) => {
      if (gallery.glide) {
        const slides = Array.from(gallery.querySelectorAll('li'));
        const activeSlide = gallery.querySelector(
          `[id^="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (activeSlide) {
          const index = slides.indexOf(activeSlide);
          gallery.glide.go(`=${index}`);
        }
      }
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    if (!productForms.length) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const BISButton = productForm.querySelector('#BIS_trigger');
      if (addButton && addButtonText) {
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      if (BISButton) {
        if (disable) {
          BISButton.style.display = 'block';
          BISButton.setAttribute('data-variant-id', this.currentVariant.id);
        } else {
          BISButton.style.display = 'none';
        }
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    if (!productForms.length) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const price = productForm.querySelector(`#price-${this.dataset.section}`);
      if (addButton && addButtonText) {
        addButtonText.textContent = window.variantStrings.unavailable;
      }
      if (price) price.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('data-id');
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const markupReturn = new DOMParser().parseFromString(
            text,
            'text/html'
          );
          if (!markupReturn || markupReturn.querySelector('parsererror')) {
            this.remove();
            return;
          }
          // Recommendations are returned in a dynamic structure without a single wrapper
          // We grab all the child nodes within recommendations and append them
          const nodes = Array.from(
            markupReturn.querySelector('product-recommendations').childNodes
          );
          if (!nodes.length) {
            this.remove();
            return;
          }
          this.textContent = '';
          nodes.forEach((node) => {
            this.appendChild(node);
          });

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products') &&
            !this.querySelector('glide-component')
          ) {
            this.remove();
          }

          const glide = this.querySelector('glide-component');
          if (glide) {
            const updateGlide = new CustomEvent('updateGlide', {
              detail: [
                {
                  id: this.id
                }
              ]
            });
            document.dispatchEvent(updateGlide);
          }

          if (this.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if (typeof p80 === typeof undefined) {
  var p80 = {};
}

p80.updateCartCount = (count) => {
  const icons = document.querySelectorAll('[data-cart-quantity]');
  if (!icons) return;
  for (var x = 0; x < icons.length; x++) {
    const countIcon = icons[x].querySelector('.cart-count-bubble');
    if ((count <= 0 && countIcon) || (!count && countIcon)) {
      countIcon.remove();
    } else if (count && countIcon) {
      const labels = countIcon.querySelectorAll('span');
      for (var y = 0; y < labels.length; y++) {
        labels[y].textContent = count;
      }
    } else if (count && !countIcon) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('cart-count-bubble');
      const aria = document.createElement('span');
      aria.setAttribute('aria-hidden', true);
      aria.innerText = count;
      const text = document.createElement('span');
      text.classList.add('visually-hidden');
      text.innerText = count;
      wrapper.appendChild(aria);
      wrapper.appendChild(text);
      icons[x].appendChild(wrapper);
    }
  }
};

/***
 *
 * Free Shipping Threshold Bar
 *
 * @param {string} (required) data-currency - The currency code of the website
 * @param {number} (required) data-threshold - the value (in cents) required to hit the free shipping threshold
 * @param {number} (optional) data-total - the total value of items in the cart on initialization (if available)
 *
 */

class ShippingBar extends HTMLElement {
  constructor() {
    super();
    // The current shop currency
    this.currency = this.getAttribute('data-currency');
    // Free shipping threshold has not been met messaging
    this.freeShippingPending = this.querySelector(
      '[data-free-shipping-pending]'
    );
    // The current cart total within the pending messaging
    this.freeShippingPendingTotal = this.freeShippingPending
      ? this.freeShippingPending.querySelector('[data-amount]')
      : null;
    // Free shipping threshold has been met messaging
    this.freeShippingMet = this.querySelector('[data-free-shipping-met]');
    // The progress bar
    this.progress = this.querySelector('progress');
    // The free shipping threshold
    this.threshold = this.getAttribute('data-threshold');
    if (this.threshold) this.threshold = parseInt(this.threshold, 10);
    // The total price of the cart
    this.cartTotal = this.getAttribute('data-total');
    if (this.cartTotal) this.cartTotal = parseInt(this.cartTotal, 10);

    // Immediately generate markup if we have the available data via liquid
    this.updateShipping();

    /***
     * Listen to broadcasted cart change event for use in multiple scenarios
     *
     * Event example:
     *
     * const cartChange = new CustomEvent('cartChange', {
     *    detail: {
     *       cartTotal: 3700 // value of the total items in the cart
     *     }
     *  });
     *  document.dispatchEvent(cartChange);
     *
     */
    document.addEventListener(
      'cartChange',
      (e) => {
        if (!e || !e.detail) return;
        this.cartTotal =
          typeof e.detail.cartTotal === typeof undefined
            ? 0
            : e.detail.cartTotal;
        this.updateShipping();
      },
      false
    );
  }

  updateShipping() {
    if (!this.threshold) return;

    const getLang = () => {
      if (navigator.languages != undefined) return navigator.languages[0];
      return navigator.language;
    };

    if (!this.cartTotal) {
      let defaultPrice = this.threshold;
      defaultPrice = defaultPrice / 100;
      defaultPrice = defaultPrice.toLocaleString(getLang(), {
        style: 'currency',
        currency: this.currency
      });
      if (this.freeShippingPendingTotal)
        this.freeShippingPendingTotal.textContent = defaultPrice;
      if (this.progress) this.progress.setAttribute('value', 0);
      return;
    }
    // Display appropriate messaging
    if (this.cartTotal >= this.threshold) {
      if (this.freeShippingPending)
        this.freeShippingPending.classList.add('hidden');
      if (this.freeShippingMet) this.freeShippingMet.classList.remove('hidden');
    } else {
      if (this.freeShippingPending)
        this.freeShippingPending.classList.remove('hidden');
      if (this.freeShippingMet) this.freeShippingMet.classList.add('hidden');
    }
    // Update the progress bar
    if (this.progress) this.progress.setAttribute('value', this.cartTotal);
    // Update the threshold offset messaging
    if (this.freeShippingPendingTotal)
      this.freeShippingPendingTotal.textContent = this.formatThreshold();
  }

  formatThreshold() {
    if (!this.cartTotal || !this.currency) return;

    const getLang = () => {
      if (navigator.languages != undefined) return navigator.languages[0];
      return navigator.language;
    };

    let price = this.threshold - this.cartTotal;
    if (price < 0) price = 0;
    price = price / 100;
    price = price.toLocaleString(getLang(), {
      style: 'currency',
      currency: this.currency
    });
    return price;
  }
}

customElements.define('shipping-bar', ShippingBar);

/***
 *
 * Accordion Component
 *
 * Creates on-page animated accordions
 *
 * @param {boolean} (optional) data-disable-desktop
 *
 * This flag will disable the accordion functionality on desktop - allowing items to behave as if they were not in an accordion at desktop resolutions
 * When true the accordions will be expanded by default on desktop - and only become toggleable on mobile
 * Think menus in the footer of the website: we display them on desktop - however on mobile they collapse into an accordion
 *
 * @param {number} (optional) data-duration - holds our animation duration for the toggle. Defaults to 100.
 *
 */

class AccordionComponent extends HTMLElement {
  constructor() {
    super();

    // The toggle button
    this.toggle = this.querySelector('[data-toggle]');
    // The content body
    this.content = this.querySelector('[data-content]');
    // Other accordions within the same container
    this.siblings = this.parentElement.querySelectorAll('accordion-component');
    // For scenarios where we only want to display the accordion options on mobile
    // This will show the content by default on desktop and hide it on mobile, as well as make it non-interactable on desktop
    this.disableDesktop = this.hasAttribute('data-disable-desktop')
      ? this.getAttribute('data-disable-desktop')
      : false;
    // Holds our animation duration for timers
    this.duration = this.hasAttribute('data-duration')
      ? parseInt(this.getAttribute('data-duration'), 10)
      : 100;
    this.timer = null;
    // Holds our open/closed state
    this.expanded = this.classList.contains('accordion__item--open')
      ? true
      : false;

    if (!this.toggle || !this.content) return;

    this.initialize();
  }

  initialize() {
    this.toggle.addEventListener('click', this.toggleAccordion.bind(this));
    if (this.disableDesktop == 'true') {
      window.addEventListener(
        'resize',
        debounce((event) => {
          this.onResize();
        }, 300).bind(this)
      );
      // Open by default on desktop when desktop controls are disabled
      if (window.innerWidth > 749) {
        this.openAccordion();
      }
    }
    this.toggleFocusable();
  }

  onResize() {
    if (this.disableDesktop == 'true' && window.innerWidth < 750) {
      this.closeAccordion();
    }
    if (this.disableDesktop == 'true' && window.innerWidth > 749) {
      this.openAccordion();
    }
  }

  toggleAccordion() {
    clearTimeout(this.timer);
    if (this.disableDesktop == 'true' && window.innerWidth > 749) return;
    if (this.expanded) {
      this.closeAccordion();
    } else {
      this.closeSiblings();
      this.openAccordion();
    }
  }

  openAccordion() {
    const accordion = this;
    this.expanded = true;
    this.classList.add('accordion__item--open');
    this.toggle.setAttribute('aria-expanded', true);
    this.content.setAttribute('aria-hidden', false);
    // Add additional height to account for the padding applied to our content
    this.content.style.maxHeight = this.content.scrollHeight + 24 + 'px';
    // Reset the max-height parameter to initial to allow responsive scaling
    this.timer = setTimeout(() => {
      accordion.content.style.maxHeight = 'initial';
    }, accordion.duration);
    this.toggleFocusable();
  }

  closeAccordion() {
    this.expanded = false;
    // Reset the max-height parameter to our set max-height to begin the animation
    // If max-height is not set to an exact value the animation will not trigger
    this.content.style.maxHeight = this.content.scrollHeight + 24 + 'px';
    // Add timeout without a parameter to start a new thread
    // Alows the max-height reset above to process and avoids animation jank
    setTimeout(() => {
      this.classList.remove('accordion__item--open');
      this.toggle.setAttribute('aria-expanded', false);
      this.content.setAttribute('aria-hidden', true);
      this.content.style.maxHeight = null;
      this.toggleFocusable();
    });
  }

  toggleFocusable() {
    const focusable = getFocusableElements(this.content);
    if (this.expanded) {
      focusable.forEach((element) => {
        element.removeAttribute('tabindex');
      });
    } else {
      focusable.forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
    }
  }

  closeSiblings() {
    if (!this.siblings || !this.siblings.length) return;

    for (var x = 0; x < this.siblings.length; x++) {
      if (this.siblings[x] === this || this.siblings[x].expanded === false)
        continue;
      this.siblings[x].closeAccordion();
    }
  }
}

customElements.define('accordion-component', AccordionComponent);

/***
 *
 * Glide Component
 *
 * A slider implementation that can be utilized with only markup knowledge
 *
 * @param {boolean} (optional) data-disable - Will stop the slider logic from loading. Useful in scenarios where we only have a single slide.
 * @param {number} (optional) data-duration - The animation duration when changing slides
 * @param {boolean} (optional) data-auto-rotate - Enables/Disables slider auto-rotation
 * @param {number} (optional) data-auto-rotate-duration - The delay between changing slides when data-auto-rotate is TRUE
 * @param {number} (optional) data-desktop-columns - The number of slides displayed on desktop. This can be a decimal/fraction.
 * @param {number} (optional) data-tablet-columns - The number of slides displayed on tablet. This can be a decimal/fraction.
 * @param {number} (optional) data-mobile-columns - The number of slides displayed on mobile. This can be a decimal/fraction.
 * @param {number/string} (optional) data-focus-at - Where to focus the slider during/after animations. Almost always 0, however 'center' is an option
 * @param {number} (optional) data-start-at - Which slide the slider starts at on initialization.
 * @param {number} (optional) data-column-gap - How much space is injected between each slide (i.e. the grid)
 * @param {boolean} (optional) data-wait-for-render
 * This will stop glide from initializing until it's manually called.
 * Sliders require their containing markup layout to be finalized before they can generate - this parameter becomes useful when content is dynamically generated or injected on page.
 *
 */

class GlideComponent extends HTMLElement {
  constructor() {
    super();
    this.disable = this.hasAttribute('data-disable')
      ? this.getAttribute('data-disable')
      : null;
    if (this.disable) {
      this.classList.add('loaded');
      return;
    }
    this.duration = this.hasAttribute('data-duration')
      ? parseInt(this.getAttribute('data-duration'), 10)
      : 400;
    this.autoRotate = this.hasAttribute('data-auto-rotate')
      ? this.getAttribute('data-auto-rotate')
      : true;
    this.autoRotateDuration = this.hasAttribute('data-auto-rotate-duration')
      ? parseInt(this.getAttribute('data-auto-rotate-duration'), 10)
      : 0;
    this.desktopColumns = 1;
    if (this.hasAttribute('data-desktop-columns')) {
      const desktopColumns = this.getAttribute('data-desktop-columns');
      // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
      this.desktopColumns = !isNaN(parseFloat(desktopColumns))
        ? parseFloat(desktopColumns)
        : 1;
    }
    this.tabletColumns = 1;
    if (this.hasAttribute('data-tablet-columns')) {
      // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
      const tabletColumns = this.getAttribute('data-tablet-columns');
      this.tabletColumns = !isNaN(parseFloat(tabletColumns))
        ? parseFloat(tabletColumns)
        : 1;
    }
    this.mobileColumns = 1;
    if (this.hasAttribute('data-mobile-columns')) {
      const mobileColumns = this.getAttribute('data-mobile-columns');
      // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
      this.mobileColumns = !isNaN(parseFloat(mobileColumns))
        ? parseFloat(mobileColumns)
        : 1;
    }
    this.focusAt = 0;
    if (this.hasAttribute('data-focus-at')) {
      // focusAt can be an integer or string per glide docs - e.g. 'center'
      const focusAt = this.getAttribute('data-focus-at');
      this.focusAt = focusAt === 'center' ? focusAt : parseInt(focusAt);
    }
    this.startAt = 0;
    if (this.hasAttribute('data-start-at')) {
      const startAt = this.getAttribute('data-start-at');
      this.startAt = !isNaN(parseInt(this.startAt, 10)) ? parseInt(startAt) : 0;
    }
    this.columnGap = this.hasAttribute('data-column-gap')
      ? parseInt(this.getAttribute('data-column-gap'), 10)
      : 16;
    this.waitForRender = this.getAttribute('data-wait-for-render')
      ? this.getAttribute('data-wait-for-render')
      : 'false';
    this.slider = this.querySelector('[data-glide]');
    this.slides = this.querySelectorAll('li');
    this.bullets = this.querySelector('[data-bullets]');
    this.pagination = this.querySelector('[data-pagination]');
    this.arrows = this.querySelector('[data-arrows]');
    this.glide = null;
    this.loader = this.querySelector('[data-loader]');
    this.id = this.hasAttribute('data-id')
      ? this.getAttribute('data-id')
      : null;

    // Add default active class for possible click/focus styles on slides
    const defaultSlide =
      this.slides && this.slides[this.startAt]
        ? this.slides[this.startAt]
        : null;
    if (defaultSlide) defaultSlide.classList.add('glide__slide--focused');

    const slider = this;
    if (typeof Glide !== typeof undefined) {
      this.bind();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        slider.bind();
      });
    }
  }

  bind() {
    const slider = this;
    if (!Glide) {
      console.error('Glide JS not found.');
      return;
    }

    slider.glide = new Glide(slider.slider, {
      type: 'slider',
      bound: true,
      focusAt: slider.focusAt,
      startAt: slider.startAt,
      perView: slider.desktopColumns,
      animationDuration: slider.duration,
      gap: slider.columnGap,
      autoplay: slider.autoRotate == 'true' ? slider.autoRotateDuration : false,
      breakpoints: {
        750: {
          perView: slider.mobileColumns,
          gap: 16
        },
        990: {
          perView: slider.tabletColumns
        }
      }
    });

    slider.glide.on('move.after', (e) => {
      if (slider.pagination) {
        const currentSlideIndicator = slider.pagination.querySelector('span');
        currentSlideIndicator.textContent = slider.glide.index + 1;
      }
    });

    slider.glide.on('mount.after', (e) => {
      slider.glide.isMounted = true;
    });

    if (slider.waitForRender != 'true') {
      slider.glide.on('build.after', function () {
        if (slider.loader) slider.loader.classList.remove('visible');
        if (slider.bullets) slider.bullets.classList.remove('hidden');
        slider.classList.add('loaded');
        setTimeout(() => {
          if (slider.arrows) slider.arrows.classList.add('visible');
        }, 500);
      });
      slider.glide.mount();
      // Add extra PDP functionality
      if (slider.extend) {
        slider.extend();
      }
    }

    /***
     * Listen to broadcasted events for updating. Mostly used in conjunction with the waitForRender option.
     *
     * Event example:
     *
     * const updateGlide = new CustomEvent('updateGlide', {
     *    detail: [
     *       {
     *          id: 'ajax-cart-upsell' // The ID of your glide-component
     *       }
     *    ]
     *  });
     *  document.dispatchEvent(updateGlide);
     *
     */
    document.addEventListener(
      'updateGlide',
      (e) => {
        if (!e || !e.detail || !e.detail.length) return;
        for (var x = 0; x < e.detail.length; x++) {
          if (e.detail[x].id !== slider.id) continue;
          if (!slider.glide) continue;
          if (slider.glide.isMounted) continue;
          if (slider.waitForRender == 'true') {
            slider.glide.mount();
            if (slider.loader) slider.loader.classList.remove('visible');
            if (slider.bullets) slider.bullets.classList.remove('hidden');
            slider.classList.add('loaded');
            setTimeout(() => {
              if (slider.arrows) slider.arrows.classList.add('visible');
            }, 500);
          }
          // Add extra PDP functionality
          if (slider.extend) {
            slider.extend();
          }
        }
      },
      false
    );

    if (slider.pagination) {
      slider.pagination
        .querySelector('[data-previous]')
        .addEventListener('click', function () {
          slider.glide.go('<');
        });
      slider.pagination
        .querySelector('[data-next]')
        .addEventListener('click', function () {
          slider.glide.go('>');
        });
    }

    // Add active class on click for possible click/focus styles on slides
    slider.slides.forEach((slide) => {
      slide.addEventListener('click', function () {
        slider.toggleActive(this);
      });
    });
  }

  toggleActive(activeSlide) {
    if (!activeSlide) return;
    this.slides.forEach((slide) => {
      slide === activeSlide
        ? slide.classList.add('glide__slide--focused')
        : slide.classList.remove('glide__slide--focused');
    });
  }

  updateIndex(index) {
    if (!this.glide || typeof index === typeof undefined) return;
    this.glide.go(`=${index}`);
  }

  update(config) {
    if (!this.glide) return;
    const slider = this;
    // config is optional - to manually override options if required
    if (config) {
      this.glide.update(config);
    } else {
      this.glide.update();
    }
  }
}

customElements.define('glide-component', GlideComponent);

/***
 *
 * Glide Product Component
 *
 * Extends GlideComponent with extra PDP functionality
 *
 * @param {string} (optional) data-link-thumbnails
 * Used in conjunction with GlideComponentProductThumbnails
 * When true the slider will look for an instance of GlideComponentProductThumbnails and sync the view of the thumbnails with the current primary slide in view in GlideComponentProduct
 *
 */

class GlideComponentProduct extends GlideComponent {
  constructor() {
    super();
    this.linkThumbnailCarousel = this.getAttribute('data-link-thumbnails')
      ? this.getAttribute('data-link-thumbnails')
      : false;
    this.thumbnailCarousel = this.parentElement.querySelector(
      'glide-component-product-thumbnails'
    );
  }

  extend() {
    const slider = this;
    if (!slider.glide) return;

    slider.glide.on('move.after', (e) => {
      slider.resizeCarousel();
      if (slider.linkThumbnailCarousel == 'true' && this.thumbnailCarousel) {
        this.thumbnailCarousel.updateIndex(slider.glide.index);
      }
    });

    slider.glide.on('resize', (e) => {
      slider.resizeCarousel();
    });

    slider.glide.on('move.after', (e) => {
      if (!slider.thumbnailCarousel || !slider.thumbnailCarousel.slides.length)
        return;
      const activeThumbnail =
        slider.thumbnailCarousel.slides[slider.glide.index];
      if (!activeThumbnail) return;
      slider.thumbnailCarousel.toggleActive(activeThumbnail);
    });
  }

  resizeCarousel() {
    const activeSlide = this.querySelector('.glide__slide--active');
    if (!activeSlide) return;
    const activeMedia = activeSlide.querySelector('.product__media');
    if (!activeMedia) return;
    const scrollHeight = activeMedia.scrollHeight;
    this.style.height = `${scrollHeight}px`;
  }
}

customElements.define('glide-component-product', GlideComponentProduct);

/***
 *
 * Glide Product Thumbnails Component
 *
 * Extends GlideComponent with extra PDP functionality
 *
 */

class GlideComponentProductThumbnails extends GlideComponent {
  constructor() {
    super();
    this.thumbnails = Array.from(this.querySelectorAll('li'));
    this.primaryCarousel = document.querySelector('glide-component-product');
  }

  extend() {
    const slider = this;
    if (slider.primaryCarousel) {
      // Update the primary GlideComponentProduct slider to match the currently clicked thumbnail
      slider.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', function () {
          slider.primaryCarousel.updateIndex(
            slider.thumbnails.indexOf(thumbnail)
          );
        });
      });
    }
  }
}

customElements.define(
  'glide-component-product-thumbnails',
  GlideComponentProductThumbnails
);

/***
 *
 * Sticky Bar
 *
 * Creates a sticky bar that will automatically watch an element on page and render itself when said element leaves the viewport
 *
 * @param {string} (optional) data-alignment - Where the sticky bar should slide in on page. 'top' or 'bottom'.
 * @param {string} (required) data-watch-element
 * What element on page the sticky bar should watch. When the element leaves the viewport the sticky bar renders itself.
 * This parameter is provided in the form of a selector string e.g. data-watch-element="#element" or data-watch-element=".product-form__buttons [type='submit']"
 *
 */

class StickyBar extends HTMLElement {
  constructor() {
    super();
    this.alignment = this.hasAttribute('data-alignment')
      ? this.getAttribute('data-alignment')
      : 'bottom';
    this.watchElementId = this.hasAttribute('data-watch-element')
      ? this.getAttribute('data-watch-element')
      : null;
    if (!this.watchElementId) {
      console.error('No watch element ID set for the Sticky Bar');
      return;
    }
    this.watchElement = document.querySelector(this.watchElementId);
    if (!this.watchElement) {
      console.error(
        `Unable to find the watch element with the ID ${this.watchElementId}`
      );
      return;
    }

    this.classList.add(`sticky-bar--${this.alignment}`);
    this.bind();
    this.checkPosition();
  }

  bind() {
    const sticky = this;
    document.addEventListener(
      'scroll',
      debounce((event) => {
        sticky.checkPosition();
      }, 100).bind(sticky)
    );
    window.addEventListener(
      'resize',
      debounce((event) => {
        sticky.checkPosition();
      }, 300).bind(sticky)
    );
  }

  checkPosition() {
    const bounding = this.watchElement.getBoundingClientRect();
    if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    ) {
      this.classList.remove('visible');
    } else {
      // Only display the item once the user has scrolled past it
      // Otherwise we'd display this immediately if our check item is below the viewport on load
      if (bounding.top > 0) {
        // Remove the active class if the user scrolls up past the target container
        this.classList.remove('visible');
        return;
      }
      this.classList.add('visible');
    }
  }
}

customElements.define('sticky-bar', StickyBar);

/***
 *
 * Ajax Cart
 *
 * Creates our Ajax Cart
 *
 * @param {string} (required) data-currency - The currently active store currency {{ cart.currency.iso_code }}
 *
 */

class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.currency = this.getAttribute('data-currency');
    if (!this.currency) {
      console.error('Currency code not specified.');
      return;
    }
    this.showCartButtons = document.querySelectorAll('[data-toggle-cart]');
    this.header = this.querySelector('[data-header]');
    this.controls = this.querySelector('[data-controls]');
    this.checkoutButton = this.querySelector('[data-checkout]');
    this.priceDisplay = this.querySelector('[data-price]');
    this.productDisplay = this.querySelector('[data-products]');
    this.noProductDisplay = this.querySelector('[data-no-products]');
    this.productSpinner = this.querySelector('[data-product-spinner]');
    this.priceSpinner = this.querySelector('[data-price-spinner]');
    this.closeButton = this.querySelector('[data-toggle-cart]');
    if (
      !this.header ||
      !this.controls ||
      !this.checkoutButton ||
      !this.priceDisplay ||
      !this.productDisplay ||
      !this.noProductDisplay ||
      !this.closeButton
    ) {
      console.error('Required markup missing.');
      return;
    }
    this.noteContainer = this.querySelector('[data-note]');
    this.noteTextArea = this.noteContainer
      ? this.noteContainer.querySelector('textarea')
      : null;
    this.productTemplate = document.getElementById(
      'ajax-cart-product-template'
    );
    if (!this.productTemplate) {
      console.error('Product template not found in markup.');
      return;
    }
    this.productTemplate = this.productTemplate.cloneNode(true);
    this.productTemplate.classList.remove('hidden');
    this.productTemplate.removeAttribute('id');

    this.isVisible = false;
    this.isUpdating = false;
    this.products = [];
    this.bind();
  }

  bind = () => {
    const cart = this;
    document.addEventListener('mousedown', function (e) {
      if (cart.isVisible) {
        if (e.target !== cart && !cart.contains(e.target)) {
          if (
            e.target.hasAttribute('data-toggle-cart') ||
            e.target.closest('data-toggle-cart')
          )
            return;
          cart.toggleCart();
        }
      }
    });
    if (cart.showCartButtons.length) {
      for (var x = 0; x < cart.showCartButtons.length; x++) {
        this.showCartButtons[x].addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            cart.toggleCart();
          },
          true
        );
      }
    }

    if (cart.noteTextArea) {
      let timeout;
      cart.noteTextArea.addEventListener('keyup', function () {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
          cart.updateNote();
        }, 500);
      });
    }
  };

  showPriceSpinner = () => {
    this.priceSpinner.classList.remove('hidden');
  };

  hidePriceSpinner = () => {
    this.priceSpinner.classList.add('hidden');
  };

  showProductSpinner = () => {
    this.productSpinner.classList.remove('hidden');
  };

  hideProductSpinner = () => {
    this.productSpinner.classList.add('hidden');
  };

  showProducts = () => {
    this.productDisplay.classList.remove('hidden');
  };

  hideProducts = () => {
    this.productDisplay.classList.add('hidden');
  };

  showEmptyCart = () => {
    this.noProductDisplay.classList.remove('hidden');
  };

  hideEmptyCart = () => {
    this.noProductDisplay.classList.add('hidden');
  };

  showPrice = () => {
    this.priceDisplay.classList.remove('hidden');
  };

  hidePrice = () => {
    this.priceDisplay.classList.add('hidden');
  };

  toggleCart = () => {
    const cart = this;
    if (this.isUpdating) return;
    if (cart.isVisible) {
      cart.classList.remove('visible');
      document.querySelector('body').classList.remove('cart-visible');
      cart.isVisible = false;
      removeTrapFocus(cart);
    } else {
      cart.isVisible = true;
      cart.fetchCart();
      cart.classList.add('visible');
      document.querySelector('body').classList.add('cart-visible');
      trapFocus(cart, cart.closeButton);
    }
  };

  updateCartUpsell = () => {
    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: 'ajax-cart-upsell'
        }
      ]
    });
    document.dispatchEvent(updateGlide);
  };

  fetchCart = () => {
    const cart = this;
    cart.showProductSpinner();
    cart.showPriceSpinner();
    cart.hidePrice();
    cart.hideProducts();
    cart.hideEmptyCart();
    cart.products = [];
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.items) {
          cart.data = data;
          cart.generateCart();
          cart.updateTotal();
        } else {
          cart.data = null;
          cart.generateCart();
          cart.updateTotal();
        }

        if (p80.updateCartCount) {
          p80.updateCartCount(data.item_count);
        }
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  };

  generateCart = () => {
    const cart = this;
    cart.productDisplay.textContent = '';
    if (cart.data.items && cart.data.items.length) {
      cart.data.items.forEach((item) => {
        const cartItem = new AjaxCartItem(cart, item);
        cart.products.push(cartItem);
        cart.productDisplay.appendChild(cartItem.html);
      });
      cart.showProducts();
      cart.hideProductSpinner();
      cart.hidePriceSpinner();
      cart.showPrice();
      cart.hideEmptyCart();
    } else {
      cart.hideProducts();
      cart.hideProductSpinner();
      cart.hidePriceSpinner();
      cart.showPrice();
      cart.showEmptyCart();
    }
    cart.addNote();
    cart.updateCartUpsell();
  };

  addNote = () => {
    const cart = this;
    if (!cart.noteTextArea) return;
    cart.noteTextArea.value = cart.data.note;
    if (cart.data.items.length == 0 && !cart.data.note)
      cart.noteContainer.classList.add('hidden');
    else cart.noteContainer.classList.remove('hidden');
  };

  updateNote = () => {
    const cart = this;
    if (!cart.noteTextArea) return;
    const postData = {
      note: cart.noteTextArea.value
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((data) => {
        cart.noteTextArea.classList.remove('error');
        cart.noteTextArea.classList.add('success');
        if (cart.noteStatusTimeout) clearTimeout(cart.noteStatusTimeout);
        cart.noteStatusTimeout = setTimeout(function () {
          cart.noteTextArea.classList.remove('success');
        }, 3000);
      })
      .catch((error) => {
        cart.noteTextArea.classList.add('error');
        console.error('Error updating note:', error);
      });
  };

  getLang = () => {
    if (navigator.languages != undefined) return navigator.languages[0];
    return navigator.language;
  };

  updateTotal = () => {
    const cart = this;
    if (!cart.data.total_price) {
      cart.priceDisplay.innerHTML = '';
      cart.priceDisplay.innerText = '$0.00';
    }
    cart.priceDisplay.innerHTML = '';
    let totalPrice = cart.data.total_price;
    totalPrice = totalPrice / 100;
    totalPrice = totalPrice.toLocaleString(this.getLang(), {
      style: 'currency',
      currency: this.currency
    });
    cart.priceDisplay.innerText = totalPrice.replace('.00', '');

    // added to get the cart total excluding the products with '_shipping-exclusion' LIP
    let shippingIncludedTotal = 0;
    cart.data.items.forEach((item) => {
      if (!item.properties['_shipping-exclusion']) {
        shippingIncludedTotal += item.final_price;
      }
    });
    
    // Broadcast cart change for the free shipping bar
    const cartChange = new CustomEvent('cartChange', {
      detail: {
        cartTotal: shippingIncludedTotal
      }
    });
    document.dispatchEvent(cartChange);
  };

  enable = () => {
    const cart = this;
    cart.isUpdating = false;
    cart.checkoutButton.classList.remove('disabled');
  };

  disable = () => {
    const cart = this;
    cart.isUpdating = true;
    cart.checkoutButton.classList.add('disabled');
  };
}

customElements.define('ajax-cart', AjaxCart);

class AjaxCartItem {
  constructor(cart, data) {
    this.data = data;
    this.cart = cart;
    this.currency = cart.currency;
    this.html = this.cart.productTemplate.cloneNode(true);
    this.image = this.html.querySelector('[data-ajax-cart-product-image]');
    this.title = this.html.querySelector('[data-ajax-cart-product-title]');
    this.subTitle = this.html.querySelector(
      '[data-ajax-cart-product-subtitle]'
    );
    this.sellingPlan = this.html.querySelector(
      '[data-ajax-cart-product-selling-plan]'
    );
    this.bundleSetOf = this.html.querySelector('[data-ajax-cart-product-set]');
    this.price = this.html.querySelector('[data-ajax-cart-product-price]');
    this.quantityInput = this.html.querySelector(
      '[data-ajax-cart-product-quantity]'
    );
    this.quantityIncrease = this.html.querySelector(
      '[data-ajax-cart-increase]'
    );
    this.quantityDecrease = this.html.querySelector(
      '[data-ajax-cart-decrease]'
    );
    this.controls = this.html.querySelector('[data-ajax-cart-controls]');
    this.discounts = this.html.querySelector(
      '[data-ajax-cart-product-discounts]'
    );

    this.amountBundle = {};
    this.amountBundleEl = this.html.querySelector(
      '.ajax-cart__product-quantity-decoy'
    );
    if (
      this.data.properties != null &&
      this.data.properties['qty_bundle_set']
    ) {
      this.amountBundle = {
        qty_orig: this.data.properties['_qty_bundle_orig'],
        qty_per_one: this.data.properties['_qty_bundle_per_one'],
        bundle_set: this.data.properties['qty_bundle_set']
      };
    } else {
      this.amountBundleEl.remove();
    }

    if (Object.keys(this.amountBundle).length) {
      this.quantityInputDecoy = this.html.querySelector(
        '[data-ajax-cart-product-quantity-decoy]'
      );
      this.quantityIncreaseDecoy = this.html.querySelector(
        '[data-ajax-cart-increase-decoy]'
      );
      this.quantityDecreaseDecoy = this.html.querySelector(
        '[data-ajax-cart-decrease-decoy]'
      );
    }

    this.isUpdating = false;
    this.generateHtml();
    this.bind();
  }

  getLang() {
    if (navigator.languages != undefined) return navigator.languages[0];
    return navigator.language;
  }

  generateHtml = () => {
    const cartItem = this;
    cartItem.image.src = cartItem.data.image;
    cartItem.title.href = cartItem.data.url;
    let title = cartItem.data.title.split(' - ');
    if (title.length) {
      title = title[0].split(' in ');
      cartItem.title.innerText = title[0];
    } else {
      cartItem.title.innerText = cartItem.data.title;
    }
    cartItem.subTitle.innerText = cartItem.data.variant_title;
    if (
      cartItem.data.selling_plan_allocation != undefined &&
      cartItem.data.selling_plan_allocation.selling_plan != undefined
    ) {
      cartItem.sellingPlan.innerText =
        cartItem.data.selling_plan_allocation.selling_plan.name;
    }
    let variantPrice = cartItem.data.final_price;
    variantPrice = Object.keys(cartItem.amountBundle).length
      ? variantPrice * Number(cartItem.amountBundle.qty_per_one)
      : variantPrice;
    variantPrice = variantPrice / 100;
    variantPrice = variantPrice.toLocaleString(this.getLang(), {
      style: 'currency',
      currency: this.currency
    });
    cartItem.price.innerText = variantPrice.replace('.00', '');

    if (Object.keys(cartItem.amountBundle).length) {
      cartItem.bundleSetOf.innerText = cartItem.amountBundle.bundle_set;
      cartItem.quantityInputDecoy.value =
        cartItem.data.quantity / Number(cartItem.amountBundle.qty_per_one);
      cartItem.quantityInput.value = cartItem.data.quantity;
    } else {
      cartItem.quantityInput.value = cartItem.data.quantity;
    }

    if (cartItem.data.discounts.length > 0) {
      cartItem.discounts.innerHTML = '';
      for (var x = 0; x < cartItem.data.discounts.length; x++) {
        const discountLine = document.createElement('div');
        let discountPrice = cartItem.data.discounts[x].amount;
        discountPrice = cartItem.quantityInputDecoy
          ? discountPrice / cartItem.quantityInputDecoy.value
          : discountPrice;
        discountPrice = discountPrice / 100;
        discountPrice = discountPrice.toLocaleString(this.getLang(), {
          style: 'currency',
          currency: this.currency
        });
        discountLine.innerText = `${cartItem.data.discounts[x].title} (-${discountPrice})`;
        cartItem.discounts.appendChild(discountLine);
      }
    } else {
      cartItem.discounts.innerHTML = '';
    }
  };

  bind = () => {
    const cartItem = this;
    cartItem.quantityIncrease.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.increaseQuantity();
    });
    cartItem.quantityDecrease.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.decreaseQuantity();
    });
    cartItem.quantityInput.addEventListener('change', function (e) {
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = parseInt(value, 10);
      cartItem.updateCartItem();
    });
    cartItem.quantityInput.addEventListener('input', function (e) {
      if (cartItem.isUpdating) {
        e.preventDefault();
        return;
      }
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = parseInt(value, 10);
    });

    if (!Object.keys(cartItem.amountBundle).length) return;
    cartItem.quantityIncreaseDecoy.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.increaseQuantityDecoy();
    });
    cartItem.quantityDecreaseDecoy.addEventListener('click', function (e) {
      e.preventDefault();
      cartItem.decreaseQuantityDecoy();
    });
    cartItem.quantityInputDecoy.addEventListener('change', function (e) {
      let value = e.target.value;
      let qtyPerOne = cartItem.amountBundle.qty_per_one;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = qtyPerOne * parseInt(value, 10);
      cartItem.quantityInput.value = cartItem.data.quantity;
      cartItem.updateCartItem();
    });
    cartItem.quantityInputDecoy.addEventListener('input', function (e) {
      if (cartItem.isUpdating) {
        e.preventDefault();
        return;
      }
      let value = e.target.value;
      let qtyPerOne = cartItem.amountBundle.qty_per_one;
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
      if (value === '' || value < 0) value = 0;
      cartItem.data.quantity = qtyPerOne * parseInt(value, 10);
      cartItem.quantityInput.value = cartItem.data.quantity;
    });
  };

  increaseQuantity = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    cartItem.data.quantity = cartItem.data.quantity + 1;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  decreaseQuantity = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    if (cartItem.data.quantity <= 0) return;
    cartItem.data.quantity = cartItem.data.quantity - 1;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  increaseQuantityDecoy = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    const decoyQty = Number(cartItem.quantityInputDecoy.value) + 1;
    const qtyPerOne = cartItem.amountBundle.qty_per_one;
    cartItem.quantityInputDecoy.value = decoyQty;
    cartItem.data.quantity = qtyPerOne * decoyQty;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  decreaseQuantityDecoy = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    if (cartItem.quantityInputDecoy.value <= 0) return;
    const decoyQty = Number(cartItem.quantityInputDecoy.value) - 1;
    const qtyPerOne = cartItem.amountBundle.qty_per_one;
    cartItem.quantityInputDecoy.value = decoyQty;
    cartItem.data.quantity = qtyPerOne * decoyQty;
    cartItem.quantityInput.value = cartItem.data.quantity;
    cartItem.updateCartItem();
  };

  updateCartItem = () => {
    const cartItem = this;
    if (cartItem.isUpdating) return;
    cartItem.isUpdating = true;
    cartItem.disable();
    cartItem.cart.disable();
    cartItem.cart.showPriceSpinner();
    cartItem.cart.hidePrice();
    const variantId = cartItem.data.variant_id;
    const quantity = cartItem.data.quantity;
    const postData = {
      updates: {
        [variantId]: quantity
      }
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((data) => {
        cartItem.cart.data = data;
        cartItem.enable();
        cartItem.cart.enable();
        cartItem.cart.updateTotal();
        cartItem.cart.hidePriceSpinner();
        cartItem.cart.showPrice();
        if (data.items && data.items.length) {
          const newData = data.items.filter(function (item) {
            return item.variant_id === variantId;
          });
          if (newData.length) {
            cartItem.data = newData[0];
            cartItem.generateHtml();
          } else {
            cartItem.removeItem();
          }
        } else {
          cartItem.cart.hideProducts();
          cartItem.cart.showEmptyCart();
        }
        cartItem.cart.addNote();
        cartItem.cart.updateCartUpsell();
        if (p80.updateCartCount) {
          p80.updateCartCount(data.item_count);
        }
      })
      .catch((error) => {
        cartItem.enable();
        cartItem.cart.enable();
        console.error('Error fetching cart:', error);
      });
  };

  removeItem = () => {
    const cartItem = this;
    const itemKey = cartItem.cart.products.findIndex((product) => {
      return product.data.variant_id === cartItem.data.variant_id;
    });
    if (itemKey >= 0) {
      cartItem.cart.products.splice(itemKey, 1);
      cartItem.html.remove();
    }
  };

  enable = () => {
    const cartItem = this;
    cartItem.isUpdating = false;
    cartItem.controls.classList.remove('disabled');
  };

  disable = () => {
    const cartItem = this;
    cartItem.isUpdating = true;
    cartItem.controls.classList.add('disabled');
  };
}

/***
 *
 * Cart Upsell Item
 *
 * Creates minimal 'product card' entries for our upsell sliders
 *
 * @param {object} (required) config - An object containing all our initialization data
 * @param {object} (required) config.product - The product data required to generated our product
 * @param {string} (required) config.id - A unique container identifier passed down through CartUpsell. This is how we generate unique IDs and aria-labels for quick-add modals
 * @param {string} (required) config.currency - The store currency code passed down through CartUpsell.
 * @param {HTMLNode} (optional) config.modalTemplate - an HTMLNode passed down through CartUpsell. This is required for generating quick-add modals (if desired).
 * @param {boolean} (optional) config.renderVariantOptions - When true, we render inline variant changers and add to cart functionality instead of using the quick-add modal
 * @param {HTMLNode} (required) config.cart - An HTMLNode passed down through CartUpsell. This is required for live-updating the cart notification shades and cart count when adding to cart.
 *
 *
 */

class CartUpsellItem {
  constructor(config) {
    if (!config) return;
    this.product = config.product;
    this.id = config.id;
    this.currency = config.currency;
    this.renderVariantOptions = config.renderVariantOptions
      ? config.renderVariantOptions
      : false;
    this.modalTemplate = config.modalTemplate
      ? config.modalTemplate.cloneNode(true)
      : null;
    this.cart = config.cart;
    this.isDisabled = false;
    this.spinner = `
    <svg class='spinner' viewBox='0 0 50 50'>
      <circle class='path' cx='25' cy='25' r='20' fill='none' stroke-width='5'></circle>
    </svg>`;
    this.generateHTML();
    this.calculateHeight();
    this.generateBadges();
    this.checkStock();
    this.bind();
  }

  generateHTML() {
    const wrapper = document.createElement('li');
    wrapper.classList.add('cart-upsell__item');

    const imageContainer = document.createElement('div');
    imageContainer.classList.add('cart-upsell__item-image');

    const imageWrapper = document.createElement('div');
    imageWrapper.classList.add('cart-upsell__item-image-wrapper');
    const image = document.createElement('img');
    image.setAttribute('loading', 'lazy');
    image.setAttribute('width', '147');
    image.setAttribute('height', '147');
    image.setAttribute(
      'alt',
      this.product.selected_or_first_available_variant.featured_image
        ? this.product.selected_or_first_available_variant.featured_image.alt
        : 'Product Image'
    );
    const imageSrc = this.product.selected_or_first_available_variant
      .featured_image
      ? this.product.selected_or_first_available_variant.featured_image.src
      : this.product.data.images[0];
    const imgSrcWithSize = imageSrc + '&width=300';
    image.src = imgSrcWithSize;
    imageWrapper.appendChild(image);
    imageContainer.appendChild(imageWrapper);

    wrapper.appendChild(imageContainer);

    const content = document.createElement('div');
    content.classList.add('cart-upsell__item-content');

    const rating = document.createElement('div');
    rating.classList.add('cart-upsell__item-rating');
    for (var x = 0; x < 5; x++) {
      const star = document.createElement('span');
      star.innerHTML = window.icons.star;
      rating.appendChild(star);
    }

    const vendor = document.createElement('p');
    vendor.classList.add('cart-upsell__item-vendor');
    vendor.textContent = this.product.data.vendor;

    const productTitle = document.createElement('p');
    productTitle.classList.add('cart-upsell__item-title', 'paragraph-small');
    productTitle.textContent = this.product.data.title;
    content.appendChild(productTitle);

    const pricing = this.generatePricing();
    content.appendChild(pricing);

    // Generates variant options
    if (this.renderVariantOptions) {
      const options = document.createElement('div');
      options.classList.add('cart-upsell__item-options');

      for (var x = 0; x < this.product.options_with_values.length; x++) {
        if (this.product.options_with_values[x].name === 'Title') continue;
        const optionWrapper = document.createElement('div');
        optionWrapper.classList.add('cart-upsell__item-option');
        const label = document.createElement('label');
        label.setAttribute(
          'for',
          `${this.product.options_with_values[x].name}-${this.product.id}-${this.id}`
        );
        label.textContent = this.product.options_with_values[x].name;
        const select = document.createElement('select');
        select.setAttribute(
          'id',
          `${this.product.options_with_values[x].name}-${this.product.id}-${this.id}`
        );
        select.setAttribute(
          'data-position',
          this.product.options_with_values[x].position
        );
        select.setAttribute(
          'data-option-name',
          this.product.options_with_values[x].name
        );
        for (
          var y = 0;
          y < this.product.options_with_values[x].values.length;
          y++
        ) {
          const option = document.createElement('option');
          option.setAttribute(
            'value',
            this.product.options_with_values[x].values[y]
          );
          option.textContent = this.product.options_with_values[x].values[y];
          select.appendChild(option);
        }
        optionWrapper.appendChild(label);
        optionWrapper.appendChild(select);
        options.appendChild(optionWrapper);
      }

      content.appendChild(options);
    }

    const addToCartWrapper = document.createElement('div');
    addToCartWrapper.classList.add('cart-upsell__item-buttons');

    const addToCart = document.createElement('button');
    addToCart.setAttribute('type', 'button');
    addToCart.classList.add(
      'button',
      'button--secondary',
      'button--small',
      'cart-upsell__item-button'
    );
    addToCart.setAttribute(
      'data-product-url',
      `/products/${this.product.data.handle}`
    );

    const addToCartSpinner = document.createElement('span');
    addToCartSpinner.classList.add('loading-overlay__spinner', 'hidden');
    addToCartSpinner.innerHTML = this.spinner;
    addToCart.appendChild(addToCartSpinner);

    const addToCartText = document.createElement('span');
    addToCartText.classList.add('cart-upsell__item-button-text');
    addToCartText.textContent = window.variantStrings.addToCart;
    addToCart.appendChild(addToCartText);

    const addToCartModalButton = document.createElement('modal-opener');
    if (
      this.product.data.variants.length > 1 &&
      this.modalTemplate &&
      !this.renderVariantOptions
    ) {
      addToCartModalButton.setAttribute(
        'data-modal',
        `#QuickAdd-${this.id}-${this.product.id}`
      );
      addToCartModalButton.appendChild(addToCart);
      addToCartModalButton.bind();
      this.modalTemplate.setAttribute(
        'id',
        `QuickAdd-${this.id}-${this.product.id}`
      );
      this.modalTemplate
        .querySelector('div')
        .setAttribute('aria-label', this.product.data.title);
      this.modalTemplate
        .querySelector('button')
        .setAttribute('id', `ModalClose-${this.id}-${this.product.id}`);
      this.modalTemplate
        .querySelector('.quick-add-modal__content-info')
        .setAttribute('id', `QuickAddInfo-${this.id}-${this.product.id}`);
      document.body.appendChild(this.modalTemplate);
    }

    addToCartWrapper.appendChild(
      this.product.data.variants.length > 1 &&
        this.modalTemplate &&
        !this.renderVariantOptions
        ? addToCartModalButton
        : addToCart
    );

    content.appendChild(addToCartWrapper);
    wrapper.appendChild(content);

    this.html = wrapper;
  }

  generatePricing() {
    const container = document.createElement('div');
    container.classList.add('cart-upsell__item-pricing', 'paragraph-small');

    const isSale =
      this.product.data.compare_at_price &&
      this.product.data.compare_at_price > this.product.data.price
        ? true
        : false;

    const regularPrice = document.createElement('p');
    regularPrice.classList.add('cart-upsell__item-price--regular');

    if (isSale) {
      regularPrice.textContent = this.formatPrice(
        this.product.data.compare_at_price
      );
      container.classList.add('cart-upsell__item-pricing--sale');
      const salePrice = document.createElement('p');
      salePrice.classList.add('cart-upsell__item-price--sale');
      salePrice.textContent = this.formatPrice(this.product.data.price);
      container.appendChild(salePrice);
    } else {
      regularPrice.textContent = this.formatPrice(this.product.data.price);
    }

    container.appendChild(regularPrice);

    return container;
  }

  formatPrice(price) {
    if (!price) return;
    let formattedPrice = price / 100;

    const getLang = () => {
      if (navigator.languages != undefined) return navigator.languages[0];
      return navigator.language;
    };

    formattedPrice = formattedPrice.toLocaleString(getLang(), {
      style: 'currency',
      currency: this.currency
    });

    return formattedPrice;
  }

  generateBadges() {
    const container = this.html.querySelector('.cart-upsell__item-image');
    const badgeMarkup = document.createElement('label');
    badgeMarkup.classList.add('cart-upsell__item-badge');

    // Create your badge generation logic below
    for (var x = 0; x < this.product.data.tags.length; x++) {
      if (this.product.data.tags[x] === 'sale') {
        const badge = badgeMarkup.cloneNode();
        badge.textContent = 'SALE';
        container.appendChild(badge);
      }
    }
  }

  updateSelectedProduct() {
    const productOptions = this.html.querySelectorAll(
      '.cart-upsell__item-options select'
    );
    const options = {};
    for (var x = 0; x < productOptions.length; x++) {
      const position = productOptions[x].getAttribute('data-position');
      const data = {
        type: productOptions[x].getAttribute('data-option-name'),
        value: productOptions[x].value
      };
      options[position] = data;
    }
    const selectedVariant = this.product.data.variants.find((variant) => {
      const totalOptions = this.product.data.options.length;
      if (totalOptions === 1) {
        if (!options[1]) return;
        if (variant.option1 === options[1].value) return variant;
      } else if (totalOptions === 2) {
        if (!options[1] || !options[2]) return;
        if (
          variant.option1 === options[1].value &&
          variant.option2 === options[2].value
        )
          return variant;
      } else if (totalOptions === 3) {
        if (!options[1] || !options[2] || !options[3]) return;
        if (
          variant.option1 === options[1].value &&
          variant.option2 === options[2].value &&
          variant.option3 === options[3].value
        )
          return variant;
      }
    });
    if (!selectedVariant) {
      console.error('Unable to find matching variant.');
      return;
    }
    this.product.selected_or_first_available_variant = selectedVariant;
    this.checkStock();
  }

  checkStock() {
    const isAvailable =
      this.product.selected_or_first_available_variant.available;
    if (!isAvailable) {
      this.disable();
    } else {
      this.enable();
    }
  }

  enable() {
    const button = this.html.querySelector('.cart-upsell__item-button');
    if (!button) return;
    button.classList.remove('disabled');
    button.removeAttribute('disabled');
    this.isDisabled = false;
  }

  disable() {
    const button = this.html.querySelector('.cart-upsell__item-button');
    if (!button) return;
    button.classList.add('disabled');
    button.setAttribute('disabled', true);
    this.isDisabled = true;
  }

  addToCart() {
    if (this.isDisabled) return;
    this.disable();
    const button = this.html.querySelector('.cart-upsell__item-button');
    if (!button) return;
    button.querySelector('.cart-upsell__item-button-text').textContent =
      window.variantStrings.addingToCart;
    button
      .querySelector('.loading-overlay__spinner')
      .classList.remove('hidden');

    const variantData = {
      id: this.product.selected_or_first_available_variant.id,
      quantity: 1,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };

    // added for shipping bar calculation to exclude products tagged with 'shipping-exclusion'
    if (this.product.shipping_excluded)
      variantData['properties'] = {
        '_shipping-exclusion': true
      };

    const formData = {
      items: [variantData]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          throw new Error(response.description);
          return;
        }
        button.querySelector('.cart-upsell__item-button-text').textContent =
          window.variantStrings.addedToCart;
        if (this.cart && this.cart.fetchCart) {
          this.cart.fetchCart();
        } else if (this.cart) {
          this.cart.renderContents(response);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.buttonTimer = setTimeout(() => {
          button.querySelector('.cart-upsell__item-button-text').textContent =
            window.variantStrings.addToCart;
        }, 3000);
        button
          .querySelector('.loading-overlay__spinner')
          .classList.add('hidden');
        this.enable();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  bind() {
    const component = this;
    const productOptions = this.html.querySelectorAll(
      '.cart-upsell__item-options select'
    );
    for (var x = 0; x < productOptions.length; x++) {
      productOptions[x].addEventListener('change', function () {
        component.updateSelectedProduct();
      });
    }
    if (this.product.data.variants.length <= 1 || !this.modalTemplate) {
      const addToCart = this.html.querySelector('.cart-upsell__item-button');
      if (addToCart)
        addToCart.addEventListener('click', function () {
          component.addToCart();
        });
    }
  }

  calculateHeight() {
    // Shopify product recommendations processes multiple times before rendering
    // This means that in a situtation where we call this in product-recommendations the image onload has likely already fired
    // First we check to see if the image already has loaded (by checking for natural width and height)
    // If it hasn't - we bind to the onload event
    const thumbnailImage = this.html.querySelector(
      '.cart-upsell__item-image-wrapper img'
    );
    const thumbnailParent = thumbnailImage.closest(
      '.cart-upsell__item-image-wrapper'
    );
    let imageHeight = thumbnailImage.naturalHeight;
    let imageWidth = thumbnailImage.naturalWidth;
    if (imageHeight && imageWidth) {
      const imageAspectRatio = (1 / (imageWidth / imageHeight)) * 100;
      if (thumbnailParent) {
        thumbnailParent.style.paddingBottom = `${imageAspectRatio}%`;
      }
      return;
    }
    thumbnailImage.onload = () => {
      imageHeight = thumbnailImage.naturalHeight;
      imageWidth = thumbnailImage.naturalWidth;
      const imageAspectRatio = (1 / (imageWidth / imageHeight)) * 100;
      if (thumbnailParent) {
        thumbnailParent.style.paddingBottom = `${imageAspectRatio}%`;
      }
    };
  }
}

/***
 *
 * Cart Upsell
 *
 * Integrates GlideComponent to create a slider which features product upsells used in multiple scenarios
 *
 * This Component is essentially a wrapper for an embedded JSON script
 * Shopify returns HTML markup vs. product data in their default product recommendations implementation
 * A component like this is the best way to handle their markup injection and keep persistent functionality while maintaining Shopify's native functionality
 *
 * @param {string} (required) data-currency - The currency code of the website
 * @param {string} (required) data-id - A specific ID for the instance of the component. This is required to integrate with GlideComponent and waitForRender options
 *
 */

class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('data-id');
    this.currency = this.getAttribute('data-currency');
    if (!this.id || !this.currency) return;

    this.productData = this.querySelector(
      '[type="application/json"]'
    ).textContent;
    if (!this.productData) return;
    this.productData = JSON.parse(this.productData);

    this.modalTemplate = this.querySelector('[data-upsell-template]');
    if (this.modalTemplate) {
      this.modalTemplate = this.modalTemplate.cloneNode(true);
      this.modalTemplate.removeAttribute('[data-upsell-template]');
    }
    this.cart =
      document.querySelector('ajax-cart') ||
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    this.products = [];

    // The way shopify handles product recommendations (multiple dom manipulations and renders) causes the component to append markup twice
    // Don't re-append if we have entries
    // Alternatively we could reset the markup each render, however that seems inefficient when it already exists
    if (!this.querySelector('li')) {
      this.generate();
    }

    // Once markup has been generated we tell the GlideComponent that it's ready to generate and render the slider
    this.initialize();
  }

  generate() {
    if (!this.productData || !this.productData.length) return;

    this.products = [];
    this.productData.forEach((product) => {
      const upsellItem = new CartUpsellItem({
        product: product,
        modalTemplate: this.modalTemplate,
        currency: this.currency,
        id: this.id,
        cart: this.cart,
        renderVariantOptions: false
      });
      this.products.push(upsellItem);

      this.querySelector('ul').appendChild(upsellItem.html);
    });
  }

  initialize() {
    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: this.id
        }
      ]
    });
    document.dispatchEvent(updateGlide);
  }
}

customElements.define('cart-upsell', CartUpsell);

/***
 *
 * Dynamic List Block
 *
 * An element within a collection/search page that can auto-inject itself at a specified index in the product/result grid. Also known as "Curated Items".
 * e.g. A client wants to add a card within the search/collection page results to advertise a specific promotion
 *
 * @param {number} (required) data-mobile-index - What element index the curated item (DynamicListBlock) will inject itself in @ mobile breakpoints
 * @param {number} (required) data-desktop-index - What element index the curated item (DynamicListBlock) will inject itself in @ desktop breakpoints
 * @param {string} (required) data-wrapper
 * The ID of the element which is the direct parent of the curated item (DynamicListBlock)/grid elements. This is the wrapper we query to inject into.
 * This will automatically search for a matching ID or class - in that order.
 * e.g. data-wrapper="wrapperElement" will first query this.closest(`#${this.wrapperId}`); and if it finds no matches will query this.closest(`.${this.wrapperID}`);
 *
 */

class DynamicListBlock extends HTMLElement {
  constructor() {
    super();
    this.mobileIndex = this.getAttribute('data-mobile-index');
    this.index = this.getAttribute('data-index');
    this.wrapperID = this.getAttribute('data-wrapper');

    if (!this.mobileIndex || !this.index || !this.wrapperID) return;

    this.wrapper = this.closest(`#${this.wrapperId}`);
    if (!this.wrapper) this.wrapper = this.closest(`.${this.wrapperID}`);
    if (!this.wrapper) return;

    this.bind();
    this.inject();
  }

  bind() {
    const block = this;
    window.addEventListener(
      'resize',
      debounce((event) => {
        block.inject();
      }, 50).bind(this)
    );
  }

  inject() {
    const injectIndex =
      window.innerWidth > 949 ? this.index - 1 : this.mobileIndex - 1;

    if (!this.wrapper.children[injectIndex]) return;

    this.classList.remove('hidden');

    // On resize relocate rather than re-append
    const existingBlock = this.wrapper.querySelector('.curated-block');
    if (existingBlock) {
      if (this.wrapper.children[injectIndex] === this) return;
      if (window.innerWidth > 989) {
        this.wrapper.insertBefore(this, this.wrapper.children[injectIndex]);
      } else {
        this.wrapper.insertBefore(this, this.wrapper.children[injectIndex + 1]);
      }
      return;
    }

    this.wrapper.insertBefore(this, this.wrapper.children[injectIndex]);
  }
}

customElements.define('dynamic-list-block', DynamicListBlock);

/***
 *
 * Volume Discounts
 *
 * Displays price breaks for multiple purchase quantities of a product based on said products tags. Supports two methods of discount generation - fixed and percentage based.
 *
 * Tag format:
 * <token>:<qty>:<price>
 *
 * e.g.
 *
 * breakp:2:10 - 10% discount off a purchase of two items
 * breakp:4:20 - 20% discount off a purchase of four items
 * breakf:2:4000 - Purchase two of this item for 4000cents each ($40.00)
 * breakf:4:3800 - Purchase four of this item for 3800cents each ($38.00)
 *
 *
 * @param {number} (required) data-price - The price of the current product being viewed in cents
 * @param {string} (required) data-currency - The currency code of the website
 *
 */

class VolumeDiscounts extends HTMLElement {
  constructor() {
    super();

    // Tags are output within a <script> element as a JSON payload rather than outputting them into data-attributes
    this.tags = this.querySelector('[type="application/json"]').textContent;
    if (!this.tags) return;

    this.tags = JSON.parse(this.tags);
    this.fixedTags = this.tags.filter((tag) => {
      return tag.includes('breakf');
    });
    this.percentageTags = this.tags.filter((tag) => {
      return tag.includes('breakp');
    });
    if (!this.fixedTags.length && !this.percentageTags.length) return;

    this.price = this.getAttribute('data-price');
    if (!this.price) return;
    this.price = parseInt(this.price, 10);

    this.currency = this.getAttribute('data-currency');
    if (!this.currency) return;

    this.chart = this.querySelector('ul');
    if (!this.chart) return;

    this.textLength = 0;

    this.generate();
  }

  generate(price) {
    const component = this;
    const priceBasis = price ? price : component.price;
    this.chart.textContent = '';
    this.percentageTags.forEach((tag) => {
      const tagData = component.formatTag(tag);
      const listEntry = component.generateHTML(tagData, priceBasis);
      component.chart.appendChild(listEntry);
    });
    this.fixedTags.forEach((tag) => {
      const tagData = component.formatTag(tag);
      const listEntry = component.generateHTML(tagData, priceBasis);
      component.chart.appendChild(listEntry);
    });
    if (this.textLength > 22) this.classList.add('paragraph-small');
    this.classList.remove('hidden');
  }

  formatTag(tag) {
    if (!tag) return;
    const splitTag = tag.split(':');
    if (splitTag.length < 3) return;
    const tagData = {
      quantity: parseInt(splitTag[1], 10),
      discount: parseInt(splitTag[2], 10),
      type: splitTag[0] === 'breakp' ? 'percentage' : 'fixed'
    };
    return tagData;
  }

  generateHTML(tagData, priceBasis) {
    if (!tagData || Object.keys(tagData).length < 3 || !priceBasis) return;
    const entry = document.createElement('li');

    const label = document.createElement('span');
    label.textContent = `${window.variantStrings.volumeDiscountBuy} ${tagData.quantity}`;

    const priceWrapper = document.createElement('span');
    priceWrapper.classList.add('volume-discounts__pricing');

    const originalPrice = this.formatPrice(priceBasis);
    let discountPrice =
      tagData.type === 'percentage'
        ? priceBasis * (1 - tagData.discount / 100)
        : tagData.discount;
    // Check and make sure the discount price is less than the original price
    // For fixed discounts, an on-sale product may end up costing "more" and should be hidden
    if (priceBasis < discountPrice) entry.classList.add('hidden');

    const originalPriceWrapper = document.createElement('span');
    originalPriceWrapper.classList.add('volume-discounts__original');
    originalPriceWrapper.textContent = originalPrice;
    priceWrapper.appendChild(originalPriceWrapper);

    discountPrice = this.formatPrice(discountPrice);
    discountPrice =
      discountPrice + ` ${window.variantStrings.volumeDiscountEach}`;
    const discountPriceWrapper = document.createElement('span');
    discountPriceWrapper.classList.add('volume-discounts__sale');
    discountPriceWrapper.textContent = discountPrice;
    priceWrapper.appendChild(discountPriceWrapper);

    const discountBadge = document.createElement('span');
    discountBadge.classList.add('volume-discounts__badge');
    if (tagData.type === 'percentage') {
      discountBadge.textContent =
        window.variantStrings.volumeDiscountSave + ` ${tagData.discount}%`;
    } else {
      const percentage = Math.floor(
        ((priceBasis - tagData.discount) / priceBasis) * 100
      ).toFixed(0);
      discountBadge.textContent =
        window.variantStrings.volumeDiscountSave + ` ${percentage}%`;
    }
    priceWrapper.appendChild(discountBadge);

    label.appendChild(priceWrapper);

    entry.appendChild(label);

    const textLength = originalPrice.length + discountPrice.length;
    if (textLength > this.textLength) this.textLength = textLength;

    return entry;
  }

  formatPrice(price) {
    if (!price) return;
    let formattedPrice = price / 100;

    const getLang = () => {
      if (navigator.languages != undefined) return navigator.languages[0];
      return navigator.language;
    };

    formattedPrice = formattedPrice.toLocaleString(getLang(), {
      style: 'currency',
      currency: this.currency
    });

    return formattedPrice;
  }
}

customElements.define('volume-discounts', VolumeDiscounts);
